import { type TransactionQueryFilters } from '../../../../../hooks/react-query/useTransactionQuery';
import { type FormAlert } from '../FormAlertArea';

export const DUPLICATE_INVOICE_TITLE = 'Duplicate invoice';

export const getDuplicateInvoiceMessage = (invoiceNumber: string) =>
  `Invoice #${invoiceNumber} already exists for this vendor. Duplicate invoices are not allowed. Search for the existing transaction and update it instead.`;

export const getDuplicateInvoiceAlert = (invoiceNumber: string): FormAlert => ({
  variant: 'destructive',
  title: DUPLICATE_INVOICE_TITLE,
  message: getDuplicateInvoiceMessage(invoiceNumber),
});

export const VERIFY_INVOICE_FAILED_ALERT: FormAlert = {
  variant: 'destructive',
  title: 'Could not verify Invoice #',
  message: 'Could not check for an existing invoice with this number. Please try again.',
};

/** Drops the duplicate-invoice alert and leaves any other alert in place. */
export const clearDuplicateInvoiceAlert = (prev: FormAlert | null) =>
  prev?.title === DUPLICATE_INVOICE_TITLE ? null : prev;

/**
 * Filter for an active transaction with the same Invoice # for the same vendor.
 * Returns null when either value is empty. Pass excludeTransactionId when editing
 * so the transaction being edited does not match itself.
 */
export const getDuplicateInvoiceFilter = (
  invoiceNumber: string,
  vendorId: number,
  excludeTransactionId?: number,
): TransactionQueryFilters | null => {
  const trimmed = invoiceNumber.trim();
  if (!trimmed || !vendorId) return null;
  return {
    invoiceNumber: trimmed,
    vendorId,
    vendorCategory: "'PickTicket','Receipt','Invoice'",
    isActive: 1,
    ...(excludeTransactionId ? { id: excludeTransactionId, notEquals: ['Id'] } : {}),
  };
};
